import MultipleChoice from "../../components/ClassOne/EnvironmentScience/Festivals/MultipleChoice";
import TrueFalse from "../../components/ClassOne/EnvironmentScience/Festivals/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/environmental-science/festivals/true-false", title: "True or False", component: TrueFalse },
    { url: "/class-one/environmental-science/festivals/multiple-choice-question", title: "Multiple Choice Question", component: MultipleChoice }
]

export default topics;